module.exports = {
  siteTitle: 'Leaked Nude Celebs',
  siteDescription:
    "Enjoy leaked OnlyFans photos & videos for free! We're collecting nude photos of celebrities / models / stars across all Internet. Regular updates, fresh content!",
  ga: 'G-SYD7YP3PXL',
};
